module.exports = __webpack_public_path__ + "img/loginBgLight.843ab6bb.gif";